import { faSchool } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@material-ui/core/Grid';
import Room from '@material-ui/icons/Room';
import Search from '@material-ui/icons/Search';
import { divIcon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import React, { useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { MapContainer, Marker, Popup, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'react-leaflet-markercluster/dist/styles.min.css';
import Select from '../../components/UI/Select/Select';
import Spinner from '../../components/UI/Spinner/Spinner';
import FetchData from '../../shared/fetchData';

const MapCntnr = (props) => {
    const [loading, setLoading] = useState(false)
    const [position, setPosition] = useState([props.lat, props.lng])
    const [showInput, setShowInput] = useState(false)
    const [showLockers, setShowLockers] = useState(false)
    const [showStates, setShowStates] = useState(false)
    const [options, setOptions] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [lockers, setLockers] = useState([])
    const [kiosks, setKiosks] = useState([])
    const [kiosk, setKiosk] = useState('')
    const [kioskInfo, setKioskInfo] = useState('')
    const [info, setInfo] = useState('')
    const [showInfo, setShowInfo] = useState(false)
    const [zoom, setZoom] = useState(props.zoom)
    const [kioskLocation, setKioskLocation] = useState(false)
    const childRef = React.useRef();
    const [lat, setLat] = useState('')
    const [lon, setLon] = useState('')
    React.useEffect(() => {
        setLat(props.lat);
        setLon(props.lng);
    }, [props.lat, props.lng])
    React.useEffect(() => {
        setPosition([lat, lon]);
    }, [lat, lon])
    React.useEffect(() => {
        setZoom(props.zoom);
    }, [props.zoom])
    React.useEffect(() => {
        setKiosks(props.kiosks)
    }, [props.kiosks])

    React.useEffect(() => {
        setPosition([props.lat, props.lon]);
    }, [props.lat, props.lon])

    const customProvider = (event) => {
        // search: async (inputValue) => {
        setSearchValue(event.target.value)
        if (event.target.value == '') {
            setOptions([])
        } else {
            var info = {
                "cityId": props.cityId,
                "text": event.target.value,
                "version": "mtpx001"
            }
            var raw = JSON.stringify(info)
            var url = 'api/v1/geonames/searchAddress'
            const inf = []
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    result.result.map(r => {
                        inf.push({
                            // bounds: r.lat + '-' + r.lon,
                            latitude: parseFloat(r.lat),
                            longitude: parseFloat(r.lon),
                            name: r.title
                        })
                    })
                    setOptions(inf)
                })
                .catch(error => console.log('error', error))
        }
    }

    const showAllLockers = (event, kioskId) => {
        setKioskLocation(false)
        const ksk = kiosks.filter(k => k.id == kioskId)
        if (ksk != null && ksk.length != 0) {
            setKiosk(ksk[0])
        }
        var info = {
            "kioskId": kioskId
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/kiosks/inquiryKiosk'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLockers(result.lockers)
                setShowLockers(true)
                setShowStates(false)
                setLoading(false)
            })
            .catch(error => setLoading(false))
    }
    const inquiryLockerStates = (event, kioskId) => {
        setKioskLocation(false)
        const ksk = kiosks.filter(k => k.id == kioskId)
        if (ksk != null && ksk.length != 0) {
            setKiosk(ksk[0])
        }
        var info = {
            "kioskId": kioskId
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/kiosks/inquiryKioskLockersStates'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setKioskInfo(result.kiosk)
                setShowStates(true)
                setShowLockers(false)
                setLoading(false)
            })
            .catch(error => setLoading(false))
    }
    const inquiryKiosk = (event, lockerId) => {
        const inf = lockers.filter(l => l.id == lockerId)
        if (inf != null && inf.length != 0) {
            setInfo(inf[0])
            setShowInfo(true)
            childRef.current.openModal()
        }
    }
    const showHideInput = (event) => {
        showInput == true ? setShowInput(false) : setShowInput(true)
        setKioskLocation(false)
    }
    const inputClass = showInput == true ? "MapInputOpen" : "MapInputOpenHide"
    const changeLocation = (lat, lon) => {
        props.changeLocation(lat, lon)
        setPosition([lat, lon])
        // childRef.current.flyTo([lat, lon])
        setOptions([])
        setShowInput(false)
        setSearchValue('')
        setKioskLocation(true)
        // childRef.current.flyTo([lat, lon]);
    }
    let optionList = ''
    if (options != null && options.length != 0) {
        optionList = options.map(o => {
            const lat = o.latitude
            const lon = o.longitude
            return <div key={o.latitude} className="MapOptions" onClick={(lat, lon) => changeLocation(o.latitude, o.longitude)}>
                {o.name}
            </div>
        })
    }

    function ChangeView({ center, zoom }) {
        const map = useMap();
        setZoom(zoom)
        map.setView(center, zoom);
        return null;
    }

    const Markers = () => {
        const map = useMapEvents({
            click(e) {
            },
        })
        return true;
    }

    function AddMarkerToClick() {
        const [markers, setMarkers] = useState([]);
        const map = useMapEvents({
            dragend: (e) => {
                if (props.hasSearch != false) {
                    props.latLngChangeHandler(e)
                    const newMarker = e.latlng
                    setMarkers([...markers, newMarker]);
                }
            }
        })

        return (
            <div>
                {markers.map(marker =>
                    <Marker position={marker}>
                    </Marker>
                )}
            </div>
        )
    }

    function ChangeMapView({ coords }) {
        const map = useMap();
        if (!kioskLocation) {
            map.setView([props.lat, props.lng], zoom);
        } else {
            map.setView([props.lat, props.lng], map.getZoom());
        }
        return null;
    }
    const afterCloseModal = (event) => {
    }

    const iconMarkupSchool = renderToStaticMarkup(<FontAwesomeIcon className="school-map-icon" icon={faSchool} />);
    const customMarkerIconSchool = divIcon({
        html: iconMarkupSchool,
    });
    //    const school = <Marker icon={customMarkerIconSchool} position={props.schoolPosition} />

    let kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        let ksk = [...kiosks]
        ksk.map(b => {
            kioskList.push({
                id: b.id,
                value: b.id,
                lat: b.lat,
                lon: b.lon,
                label: b.description,
                description: b.description,
            })
        })
    }

    const content = <div className='row justify-content-center'>
        <div className='kiosk-map-cntnr'>
            <div className='row ml-0 mr-0'>
                <Select
                    name="form-field-name"
                    value={props.kiosk}
                    placeholder="لاکر"
                    options={kioskList}
                    className="map-geo"
                    onChange={(value) => props.changeLocationOnKiosk(value)}
                    col="6 mt-3"
                />
            </div>
            <div className='row justify-content-center ml-0 mr-0'>
                <MapContainer
                    scrollWheelZoom={false}
                    className={[props.className, "MapMapContainer"].join(' ')}
                    center={[props.lat, props.lng]}
                    backgroundColor='red'
                    zoom={props.zoom}
                >
                    {props.start ? <Markers /> : ''}

                    <TileLayer
                        url="https://pm2.parsimap.com/comapi.svc/tile/parsimap/{x}/{y}/{z}/a8e721a4-abbb-4849-8ec2-3262826a6e6e"
                    />
                    <MarkerClusterGroup showCoverageOnHover={false}>
                        {kiosks.map(o => {
                            const iconMarkup = renderToStaticMarkup(<Room className="marker-ksk" />);
                            const customMarkerIcon = divIcon({
                                html: iconMarkup,
                            })
                            return (<Marker eventHandlers={{
                                click: (e) => {
                                    e.target.openPopup();
                                },
                            }} key={o.id} icon={customMarkerIcon} position={[o.lat, o.lon]} >
                                <Popup>
                                    <div className='popup-cntnr'>
                                        <div className='row justify-content-center popup-row'>
                                            <div className="map-ksk-icon">{o.description}</div>
                                        </div>
                                        <hr />
                                        <div className='row justify-content-center popup-row'>
                                            <div onClick={(event) => props.setKioskId(o)}>انتخاب</div>
                                        </div>
                                    </div>
                                </Popup>
                            </Marker>)
                        })}
                    </MarkerClusterGroup>
                    <ChangeMapView />
                    {props.hasSearch != false ?
                        <div className="p-3 pr-4" style={{ position: 'absolute', width: '50%' }}>
                            <div className="row">
                                <div onClick={showHideInput} style={{ width: '8%' }}>
                                    <Grid container className="root">
                                        <Search className="Mapicon MapSearch" />
                                    </Grid>
                                </div>
                                <div style={{ position: 'absolute', paddingRight: '11%' }}>
                                    <input value={searchValue} onChange={customProvider} className={inputClass} name="search_ksk_map" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="MapOptionCntnr">
                                    <div className="MapOptionList">
                                        {optionList}
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''}
                </MapContainer>
                {props.extraInfo}
            </div>
        </div>
    </div>
    if (lockers != null && lockers.length != 0) {
        lockers.sort((a, b) => {
            return a.serial - b.serial;
        })
    }

    const spinner = loading ? <Spinner /> : ''
    return (
        <div>
            {spinner}
            {content}
        </div>
    )
}
export default MapCntnr
